window.addEventListener('DOMContentLoaded', () => {
    const mask_container_dom = document.querySelector('.section-mask-container');
    mask_container_dom.addEventListener('scroll', (event) => {
      event.preventDefault();
      pageRate();
    });
    mask_container_dom.addEventListener('wheel', (event) => {
      event.preventDefault();
      mask_container_dom.scrollLeft += event.deltaY;
      pageRate();
    });
    function pageRate() {
      let scrollLeft = mask_container_dom.scrollLeft; // 已经读过被卷起来的文档部分
      let scrollWidth = mask_container_dom.scrollWidth;
      let clientwidth = document.documentElement.clientWidth; // 窗口可视宽度
      $('.mask-close-ward').css({
        ['--line-width']: (scrollLeft / (scrollWidth - clientwidth)).toFixed(2) * 100 + '%',
      });
    }
  });